<template>
  <div>
    <el-dialog :title="this.isCreated ? `新增任务配置` : `编辑任务配置`" center :visible="true" @close="onClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="731px">
      <el-form ref="form" :model="form" label-width="130px" size="mini" style="margin-right: 50px">
        <el-form-item label="任务Key：" prop="key">
          <el-input placeholder="根据实际需要填，比如可以代表某种ID、也可以代表第几天等" style="width: 400px" v-model="form.key"></el-input>
        </el-form-item>
        <el-form-item label="解锁类型：" prop="unlockType">
          <el-input placeholder="" style="width: 250px" v-model="form.unlockType"></el-input>
        </el-form-item>
        <el-form-item label="解锁条件：" prop="unlockParams">
          <el-input placeholder="" style="width: 250px" v-model="form.unlockParams"></el-input>
        </el-form-item>
        <el-form-item label="任务类型：" prop="taskType">
          <el-input placeholder="一般是填游戏预定义的某个整数" style="width: 250px" v-model="form.taskType"></el-input>
        </el-form-item>
        <el-form-item label="任务条件：" prop="schedule">
          <el-input placeholder="一般是填数字" style="width: 250px" v-model="form.schedule"></el-input>
        </el-form-item>
        <el-form-item label="类型判断：" prop="typeDetermination">
          <el-input placeholder="1：读历史进度； 2：不读历史进度" style="width: 250px" v-model="form.typeDetermination"></el-input>
        </el-form-item>
        <el-form-item label="任务描述：" prop="taskInfo">
          <el-input placeholder="一般是填多语言key" style="width: 250px" v-model="form.taskInfo"></el-input>
        </el-form-item>
        <el-form-item label="奖励：">
          <base-item-selector @updated="updatedItemSelector" v-model="form.rewards"></base-item-selector>
        </el-form-item>
        <el-form-item label="奖励领取方式：" prop="collectionMethod">
          <el-input placeholder="1：直接领取；2：观看广告后领取" style="width: 250px" v-model="form.collectionMethod"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const util = require("@/util");
import BaseItemSelector from "@/pages/activity/activity_parameter_template/biz-components/BaseItemSelector";

// 本弹窗名称
const DialogName = "EditActivityTaskDialog";

export default {
  data() {
    return {
      form: {
        key: "",
        unlockType: "",
        unlockParams: "",
        taskType: "",
        typeDetermination: "",
        taskInfo: "",
        schedule: "",
        rewards: [],
        collectionMethod: "",
      },
      isCreated: false,
      itemSelectorResult: [],
    };
  },

  async created() {
    let value = this.$dialogutil.getData(DialogName);
    if (value.entry != null) {
      this.form = value.entry;
    }
    this.isCreated = value.isCreated;
  },

  components: {
    BaseItemSelector,
  },

  methods: {
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async submit() {
      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认新增（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();
        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.closeWithParam(param);
      } catch (e) { }
    },

    async update() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认修改（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();

        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.closeWithParam(param);
      } catch (e) { }
    },

    save() {
      let key = this.form.key.trim();
      if (key == "") {
        return { errMsg: "请正确填写“任务Key”" };
      }

      let taskType = this.form.taskType.trim();
      if (taskType == "") {
        return { errMsg: "请正确填写“任务类型”" };
      }

      if (this.itemSelectorResult.errMsg) {
        return { errMsg: this.itemSelectorResult.errMsg };
      }
      let rewards = this.itemSelectorResult;
      if (rewards.length == 0) {
        return { errMsg: "奖励最少配置一项" };
      }

      return {
        key: key,
        unlockType: this.form.unlockType,
        unlockParams: this.form.unlockParams,
        taskType: taskType,
        typeDetermination: this.form.typeDetermination,
        taskInfo: this.form.taskInfo,
        schedule: this.form.schedule,
        rewards: rewards,
        collectionMethod: this.form.collectionMethod,
      };
    },

    async updatedItemSelector(param) {
      this.itemSelectorResult = param;
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },

    closeWithParam(param) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName, param);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}

.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>
